import { useMemo } from "react"
import { CompanyUsageKind } from "schema"
import { useAuthEmployeeQuery } from "./useAuthEmployeeQuery"

export function useHasCompanyFeature(usage: keyof typeof CompanyUsageKind) {
  const { data: employeeData } = useAuthEmployeeQuery()

  return useMemo(() => {
    if (!employeeData) return false

    return employeeData.company?.usages.some((us) => us === usage) ?? false
  }, [employeeData, usage])
}
